module.exports = __webpack_public_path__ + "img/user-avatar-5.127a0e9b.png";